import React from "react";
import { Flex } from "@chakra-ui/react";
import { env } from "../../config";
import { strings } from "../../localization";
import { colors } from "../../theme/colors";
import Link from "./components/Link";
import Title from "./components/Title";
import { useNavigateCustom } from "../../hooks";

export const LinkList = () => {
	const {
		components: {
			footer: { list },
		},
	} = strings;
	const navigate = useNavigateCustom();

	return (
		<Flex direction={{ base: "column", lg: "row" }} gap={{ base: "32px", lg: "80px" }}>
			<Flex direction="column" gap="8px">
				<Link
					onClick={() => window.open(env.blob.termsOfConditions, "_blank")}
					color={colors.white[500]}
					fontSize={{ base: "18px", lg: "20px" }}
					lineHeight={{ base: "24px", lg: "28px" }}
				>
					{list.column_one.link_one}
				</Link>
				<Title marginTop={{ base: "24px", lg: "0px" }}>{list.column_one.title}</Title>
				<Link href="https://www.vivomoney.com.br/emprestimo-pessoal">{list.column_one.link_two}</Link>
				<Link onClick={() => navigate("/")}>{list.column_one.link_three}</Link>
				<Link href="https://www.vivomoney.com.br/creditodotrabalhador/">{list.column_one.link_four}</Link>
			</Flex>
			<Flex direction="column" gap="8px">
				<Title onClick={() => window.open("https://www.vivopay.com.br/seguros", "_blank")}>
					{list.column_two.title}
				</Title>
				<Link href="https://www.vivopay.com.br/seguro-celular" target="_blank">
					{list.column_two.link_one}
				</Link>
				<Link href="https://www.vivopay.com.br/seguro-eletronicos" target="_blank">
					{list.column_two.link_two}
				</Link>
				<Link href="https://www.vivopay.com.br/seguro-residencial" target="_blank">
					{list.column_two.link_third}
				</Link>
			</Flex>
			<Flex direction="column" gap="8px">
				<Title>{list.column_three.title}</Title>
				<Link
					href="https://consorcio.vivo.com.br/?utm_source=Vivo&utm_medium=portalMoney&utm_campaign=portalMoney_menu"
					target="_blank"
				>
					{list.column_three.link_two}
				</Link>
				<Link
					onClick={() => {
						window.open("https://www.vivopay.com.br/credito-antecipado");
					}}
					target="_blank"
				>
					{list.column_three.link_three}
				</Link>
			</Flex>
		</Flex>
	);
};
